<template>
  <div > 
    <br><br>
    <b-form @submit="store">
        <div class="row justify-content-center">
          <div class="col-md-8">
                <br><br v-if="!isMobile">
                <h1 class="text-center" style="font-size: 30px; color: #50533A;"><b>GESTOR DE SOLICITUDES IDPDV</b></h1>
                <P class="text-center" style="font-size: 25px; color: #50533A;">Canal Especialista</P> 
                <center><u class="text-center" style="color: #019DF4; font-size: 17px; cursor: pointer;"  @click="regresaInicio()">Regresar</u></center>
                <br>
            </div> 
            <div class="col-md-12 col-11" >
               <div class="row justify-content-center" style="background:#f6f6f6;">
                 <div class="col-md-12">
                    <br>
                        <center>
                                <p>¿El IDPDV pertenecerá a un proyecto?:</p>
                                <br> 
                                <b-form-radio-group
                                    v-model="selected"
                                    :options="options"
                                    class="mb-3"
                                    value-field="item"
                                    text-field="name"
                                    disabled
                                    style="font-size: 17px;"
                                    @change="limpiaSelect()"
                                ></b-form-radio-group>
                                <br v-if="selected == 'SI'"> 
                                <label for="" style="font-size: 17px;" v-if="selected == 'SI'">Indica el tipo de proyecto:</label>
                                <select class="form-control mt-4" v-model="tipo_proyecto" :style="isMobile ? 'border-radius: 6px; box-shadow: inset 0 0 10px 0 #CDCDCD; width: 60%;' : 'border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD; width: 20%;'"
                                         v-if="selected == 'SI'" @change="limpiaProyecto()">
                                    <option value="" selected disabled>Selecciona una opción</option> 
                                    <option value="Prepago masivo">Prepago masivo</option>
                                    <option value="Redireccionamiento">Redireccionamiento</option>
                                    <option value="Cadenas">Cadenas</option>
                                </select>  
                                <br v-if="tipo_proyecto == 'Prepago masivo'"> 
                                 <label for="" style="font-size: 17px;" v-if="tipo_proyecto == 'Prepago masivo'">Indica el tipo de modelo:</label>
                                <select class="form-control mt-4" v-model="tipo_modelo" :style="isMobile ? 'border-radius: 6px; box-shadow: inset 0 0 10px 0 #CDCDCD; width: 60%;' : 'border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD; width: 20%;'" v-if="tipo_proyecto == 'Prepago masivo'">
                                    <option value="" selected disabled>Selecciona una opción</option> 
                                    <option value="Zonificado">Zonificado</option>
                                    <!-- <option value="Desarrollo territorial">Desarrollo territorial</option> -->
                                    <option value="Híbrido">Híbrido</option>
                                </select>  
                                <br><br  v-if="selected == 'SI'">
                        </center>
                 </div>  
              </div>
              <div class="row justify-content-center">
                <div class="col-md-10 mt-5" v-if="tipo_proyecto == 'Redireccionamiento' && tipo_modelo == '' && selected == 'SI'  || tipo_proyecto == 'Cadenas' && tipo_modelo == '' && selected == 'SI' 
                    || tipo_proyecto == 'Prepago masivo' && tipo_modelo != '' && selected == 'SI' || selected == 'NO'">
                    <br>
                    <p class="text-center"  style="font-size: 17px;">Por favor ingresa los siguientes datos solicitados:</p>
                    <br>
                    <div class="row justify-content-center mt-5">
                        <div class="col-md-3">
                           <label for="" style="font-size: 17px;" class="ml-5">Nombre de la solicitud:</label>
                           <b-form-input placeholder="Nombre" v-model="nombre_solicitud" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
                           <small v-if="errors.includes('nombre_solicitud')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div>
                        <div class="col-md-3">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'mt-5 ml-5' : 'ml-5'">Escribe DI:</label>
                           <b-form-input placeholder="000000" v-model="di" class="form-control form-control-lg"  maxlength="6" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
                            <small v-if="errors.includes('di')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> <br>
                             <small v-if="errors.includes('dim')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                El campo debe contener 6 dígitos
                            </small> 
                        </div>
                        <div class="col-md-3">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'mt-5 ml-5' : 'ml-5'">Nombre del distribuidor:</label>
                           <b-form-input placeholder="Distribuidor" v-model="nombre_distribuidor"  class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
                            <small v-if="errors.includes('nombre_distribuidor')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div>
                        <div class="col-md-3">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'mt-5 ml-5' : 'ml-5'">Calle y número:</label>
                           <b-form-input placeholder="Calle / 0000" v-model="calle" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
                           <small v-if="errors.includes('calle')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div>
                        <div class="col-md-3 mt-5">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'ml-5' : ' mt-5 ml-5'">NIR / Zona:</label>
                           <b-form-input placeholder="00000" v-model="nir" class="form-control form-control-lg" maxlength="3"  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
                            <small v-if="errors.includes('nir')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> <br>
                             <small v-if="errors.includes('nirm')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                El campo debe contener mínimo 2 dígitos máximo 3
                            </small>  
                        </div>
                        <div class="col-md-3 mt-5">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'ml-5' : ' mt-5 ml-5'">Municipio:</label>
                           <b-form-input placeholder="Escribe aquí" v-model="municipio" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
                           <small v-if="errors.includes('municipio')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div>
                        <div class="col-md-3 mt-5">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'ml-5' : ' mt-5 ml-5'">Estado:</label>
                              <select class="form-control" aria-label="Default select example" v-model="estado" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;">
                                <option value="" selected>Selecciona un estado</option>
                                <option value="Aguascalientes">Aguascalientes</option>
                                <option value="Baja California">Baja California</option>
                                <option value="Baja California Sur">Baja California Sur</option>
                                <option value="Campeche">Campeche</option>
                                <option value="Chiapas">Chiapas</option>
                                <option value="Chihuahua">Chihuahua</option>
                                <option value="Coahuila">Coahuila</option>
                                <option value="Colima">Colima</option>
                                <option value="CDMX">CDMX</option>
                                <option value="Durango">Durango</option>
                                <option value="Guanajuato">Guanajuato</option>
                                <option value="Guerrero">Guerrero</option>
                                <option value="Hidalgo">Hidalgo</option>
                                <option value="Jalisco">Jalisco</option>
                                <option value="México">México</option>
                                <option value="Michoacán">Michoacán</option>
                                <option value="Morelos">Morelos</option>
                                <option value="Nayarit">Nayarit</option>
                                <option value="Nuevo León">Nuevo León</option>
                                <option value="Oaxaca">Oaxaca</option>
                                <option value="Puebla">Puebla</option>
                                <option value="Querétaro">Querétaro</option>
                                <option value="Quintana Roo">Quintana Roo</option>
                                <option value="San Luis Potosí">San Luis Potosí</option>
                                <option value="Sinaloa">Sinaloa</option>
                                <option value="Sonora">Sonora</option>
                                <option value="Tabasco">Tabasco</option>
                                <option value="Tamaulipas">Tamaulipas</option>
                                <option value="Tlaxcala">Tlaxcala</option>
                                <option value="Veracruz">Veracruz</option>
                                <option value="Yucatán">Yucatán</option>
                                <option value="Zacatecas">Zacatecas</option>
                            </select> 
                            <small v-if="errors.includes('estado')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div>
                        <div class="col-md-3 mt-5">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'ml-5' : ' mt-5 ml-5'">C.P.:</label>
                           <b-form-input placeholder="00000"  v-model="cp" maxlength="5" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
                            <small v-if="errors.includes('cp')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> <br>
                             <small v-if="errors.includes('cpm')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                El campo debe contener 5 dígitos
                            </small> 
                        </div>
                        <div class="col-md-3 mt-5" v-if="tipo_proyecto == 'Redireccionamiento' || tipo_proyecto == 'Cadenas' || selected == 'NO'">
                            <label for="" style="font-size: 17px;" class="ml-5 mt-5">Indica el tipo de IDPDV:</label>
                            <select class="form-control mt-4" v-model="tipo_idpdv" style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;">
                                <option value="" selected disabled>Selecciona una opción</option> 
                                <option value="Cambaceo">Cambaceo</option>
                                <option value="Tienda">Tienda</option> 
                            </select>                       
                           <small v-if="errors.includes('tipo_idpdv')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div> 
                        <div class="col-md-12 ">
                          <br>
                          <div class="row justify-content-center "> 
                              <div class="col-md-4 mt-3" v-for="list in obj.archivo" :key="list.id"> 
                                <center>
                                <a target="_blank" :href="$api.baseUriFiles+'gestor/' + list.testigo">
                                  <u style="font-size: 22px; color:#019DF4; cursor: pointer;">Testigo</u> 
                                </a> 
                                <u class="ml-5" style="font-size: 22px; color:#E63780; cursor: pointer;" @click="eliminaTestigo(list.id)">Eliminar</u>
                                </center>
                              </div> 
                          </div>
                        </div>
                        <div class="col-md-6 mt-5">
                            <br>
                            <center> 
                                <label for="" style="font-size: 18px;"  class="ml-5 mt-5" v-if="selected == 'SI'">Adjuntar archivo (Soporte / VoBo)</label>
                                <file-pond  ref="pond" style="color:#fff;"
                                            :label-idle="isMobile ? 'Clic aquí para subir tus fotos. Máximo 3 imágenes.' : 'Arrastra o da clic aquí para subir tus fotos. Máximo 3 imagen.'"
                                            v-bind:allow-multiple="true"
                                            accepted-file-types="image/*">

                                    <template v-slot:label></template>

                                </file-pond> 
                                <small class="text-center" style="color:#999;">Formatos .doc .xlxs .pdf, .jpg, .png y .msg</small>
                                <br>
                                <small v-if="errors.includes('imagen')" class="text-danger mt-2 text-left">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Este campo es obligatorio
                                </small> 
                            </center>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="col-md-7 mt-5 text-center"  v-if="tipo_proyecto == 'Redireccionamiento' && tipo_modelo == '' && selected == 'SI'  || tipo_proyecto == 'Cadenas' && tipo_modelo == '' && selected == 'SI' 
                    || tipo_proyecto == 'Prepago masivo' && tipo_modelo != '' && selected == 'SI' || selected == 'NO'"> 
                <br>    
                <button :disabled="loader" class="btn btn-success float-center btn-sm mt-3 ml-4" type="submit" 
                :style="isMobile ? 'border-radius: 26px; width: 45%; background: #62B22F; border-color: #62B22F; font-size:17px;' 
                :'border-radius: 26px; width: 15%; background: #62B22F; border-color: #62B22F; font-size:17px;'">
                    <span v-if="!loader">
                        Enviar
                    </span>
                    <span v-else>
                    <b-spinner small></b-spinner> Enviando...
                    </span>
                </button>
            </div> 
        </div>  
    </b-form>  
    <br><br><br><br><br>

  
  </div>
</template>
<script> 
// import moment from 'moment';
import Swal from 'sweetalert2' 
// import $ from 'jquery';  
import 'bootstrap';
import vueFilePond from 'vue-filepond'; 
const FilePond = vueFilePond();
export default {
    name:"Registro", 
    components: { 
      FilePond 
    },
     data() {
        return {
          isMobile: this.$mobile(),
          errors:[],
          loader:false, 
          selected: '',
          options: [
            { item: 'SI', name: 'SI' },
            { item: 'NO', name: 'NO' }
          ],
          tipo_proyecto:"",
          tipo_modelo:"",
          nombre_solicitud:"",
          di:"",
          nombre_distribuidor:"",
          calle:"",
          nir:"",
          municipio:"",
          estado:"",
          cp:"",
          tipo_idpdv:"",
          idgestor:0,
          obj:{}
       }
     },  
     computed: {
        user() {
            return this.$store.getters.getInfoUser;
        },
     },
     methods:{ 
        eliminaTestigo(id){
          var url= 'admin/gestor_prueba/eliminaT?id='+ id;
            this.$api.get(url).then(
                    ({data}) => {
                      console.log(data);
                      this.traeInformacion();
                      Swal.fire(
                        "¡List@!",
                        "Testigo eliminado correctamente",
                        "success"
                        )
                    }
                );
        },
        regresaInicio(){
          window.location.href = "https://gestionprueba.asistentemovistar.com.mx";
        },
        store(e){
            e.preventDefault();           
            this.errors = [];  
             let files = !this.testigo ?  this.$refs.pond.getFiles() : [];
            if(!this.nombre_solicitud){ 
                this.errors.push('nombre_solicitud');  
            }if (!this.di){ 
                this.errors.push('di');  
            }if (this.di.length < 6){ 
                this.errors.push('dim');  
            }if (!this.nombre_distribuidor){ 
                this.errors.push('nombre_distribuidor');  
            }if (!this.calle){ 
                this.errors.push('calle');  
            }if (!this.nir){ 
                this.errors.push('nir');  
            }if (this.nir.length == 1){ 
                this.errors.push('nirm');  
            }if (!this.municipio){ 
                this.errors.push('municipio');  
            }if (!this.estado){ 
                this.errors.push('estado');  
            }if (!this.cp){ 
                this.errors.push('cp');  
            }if(files.length == 0 && this.tipo_proyecto == 'Prepago masivo' ){
                 this.errors.push('imagen');   
            }if (this.cp.length < 5){ 
                this.errors.push('cpm');  
            }if (!this.tipo_idpdv && this.tipo_proyecto != 'Prepago masivo' || !this.tipo_idpdv && this.selected == 'NO'){ 
                this.errors.push('tipo_idpdv');  
            }if (!this.tipo_modelo && this.tipo_proyecto == 'Prepago masivo'){ 
                this.errors.push('tipo_modelo');  
            }if(this.errors.length == 0){
                this.loader = true;
                let model = this.prepareModel();
                this.$api.post("admin/gestor_prueba/editar2", model).then(
                response => {
                    this.loader = false;  
                    Swal.fire(
                    "¡List@!",
                     "Se ha editado correctamente tu solicitud",
                    "success"
                    )
                    this.clear();
                    this.regresaInicio();
                    console.log(response)
                },
                error => {
                    this.loader = false;
                    if (error.api) {
                         this.errors = error.api; 
                    }
                }
                )
             }
        },
        prepareModel() { 
             var model = new FormData();
                model.append("id", this.idgestor); 
                model.append("pertenece", this.selected); 
                model.append("iduser", this.user.id); 
                model.append("tipo_proyecto", this.tipo_proyecto); 
                model.append("tipo_modelo", this.tipo_modelo); 
                model.append("nombre_solicitud", this.nombre_solicitud); 
                model.append("di", this.di); 
                model.append("nombre_distribuidor", this.nombre_distribuidor);
                model.append("calle", this.calle); 
                model.append("nir", this.nir);  
                model.append("municipio", this.municipio); 
                model.append("estado", this.estado); 
                model.append("cp", this.cp); 
                model.append("tipo_idpdv", this.tipo_idpdv);  

                    let files = this.$refs.pond.getFiles();
                    files.forEach((file) => {
                        model.append("archivos[]", file.file);
                    });
                return model;
        }, 
        clear(){
            this.selected = "";
            this.tipo_proyecto = "";
            this.tipo_modelo = "";
            this.nombre_solicitud = "";
            this.di = "";
            this.nombre_distribuidor = ""; 
            this.calle = ""; 
            this.nir = "";
            this.municipio = "";
            this.estado = "";
            this.cp = ""; 
            this.tipo_idpdv = ""; 
            this.errors = [];
            this.$refs.pond.removeFiles();
        },   
        limpiaProyecto(){
            this.tipo_modelo = "";
            this.nombre_solicitud = "";
            this.di = "";
            this.nombre_distribuidor = ""; 
            this.calle = ""; 
            this.nir = "";
            this.municipio = "";
            this.estado = "";
            this.cp = ""; 
            this.tipo_idpdv = ""; 
            this.errors = [];
            this.$refs.pond.removeFiles();
        },
        limpiaSelect(){
            this.tipo_proyecto = "";
            this.tipo_modelo = "";
            this.nombre_solicitud = "";
            this.di = "";
            this.nombre_distribuidor = ""; 
            this.calle = ""; 
            this.nir = "";
            this.municipio = "";
            this.estado = "";
            this.cp = ""; 
            this.tipo_idpdv = ""; 
            this.errors = [];
            this.$refs.pond.removeFiles();
        },
        traeInformacion(){
          var url= 'admin/gestor_prueba/getEdit?id='+ this.idgestor;
            this.$api.get(url).then(
                    ({data}) => {
                      console.log(data);
                        this.obj = data.data.list;
                        this.selected = this.obj.pertenece;
                        this.tipo_proyecto = !this.obj.tipo_proyecto ? '' : this.obj.tipo_proyecto;
                        this.tipo_modelo = !this.obj.tipo_modelo ? '' : this.obj.tipo_modelo;
                        this.nombre_solicitud = this.obj.nombre_solicitud;
                        this.di = this.obj.di;
                        this.nombre_distribuidor = this.obj.nombre_distribuidor; 
                        this.calle = this.obj.calle_numero; 
                        this.nir = this.obj.nir_zona;
                        this.municipio = this.obj.municipio;
                        this.estado = this.obj.estado;
                        this.cp = this.obj.cp; 
                        this.tipo_idpdv = !this.obj.tipo_idpdv ? '' : this.obj.tipo_idpdv; 
                    }
                );
        }
     },
     mounted(){
           this.idgestor = this.$route.params.folio;
           this.traeInformacion();
     } 
}

 
</script>
<style > 
  #pagi a {
    background: none;
    color: #85848A;
    transition: all 300ms ease;
  }


  #inde{
    z-index: 5;
  }

  .table-su{
    background: #CAF5A8;
  }

  #global {
	height: 470px;
	width: 100%; 
	overflow-y: scroll;
}


.filepond--drop-label {
     background-color: #000 !important;
    box-shadow: 0px 10px 10px -6px black;
    cursor: pointer;
    color: #fff; 
}

#filepond--drop-label-96imw404a{
    font-weight: bold; color: #000;
}
</style>